import {IEventManagerWithAsync} from '@gongxigames/framework/core';

export * from './StrictAutoplayEvents';
export * from './BuyFeatureEvents';
export * from './FlowEvents';
export * from './GameHistoryEvents';
export * from './GlobalEventsMap';
export * from '../../core/events/MessageEvents';
export * from './SlotEvents';
export * from './StrictWinPresentationEvents';
export * from '../../core/events/SystemPopupsEvents';
export * from './UIEvents';
export * from './SlotGameEvents';
export * from './WindowEvents';
export * from './NetworkEvents';

import {GlobalEventsMap} from './GlobalEventsMap';

export type IGlobalEventManger = IEventManagerWithAsync<GlobalEventsMap>;
